import { useQuery } from "@tanstack/react-query";
import { ksUserQK } from "../lib/query-keys";
import { findUser } from "../lib/queries/user-queries";
import Title from "../components/ui/Title";
import Box from "../components/ui/Box";
import { Skeleton } from "../components/ui/skeleton";
import MonSyndicat from "../components/syndicat/MonSyndicat";
import PasDeSyndicat from "../components/syndicat/PasDeSyndicat";

const SyndicatPage = () => {
  const { data: user } = useQuery({
    queryKey: [ksUserQK],
    queryFn: findUser,
  });

  return (
    <>
      <Title className="mb-6">Mon syndicat</Title>
      <Box>
        {/* LOADING */}
        {!user && <Skeleton className="h-32 w-full" />}

        {/* Pas de syndicat */}
        {!!user && !user.syndicat && <PasDeSyndicat />}

        {/* Un syndicat */}
        {!!user && user.syndicat && <MonSyndicat syndicat={user.syndicat} />}
      </Box>
    </>
  );
};

export default SyndicatPage;
